import { render, staticRenderFns } from "./AddNewCustomer.vue?vue&type=template&id=c46e00d6&scoped=true&"
import script from "./AddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./AddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCustomer.vue?vue&type=style&index=0&id=c46e00d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e00d6",
  null
  
)

export default component.exports